module.exports = __webpack_public_path__ + "static/media/ic_done_circle.8e6c5064.svg";